import React, { ButtonHTMLAttributes } from 'react'
import * as S from './styles'

type Props = ButtonHTMLAttributes<HTMLButtonElement>

export function ButtonBlueContained({ children, ...props }: Props) {
  return <S.ButtonBlueContained {...props}>
    {children}
  </S.ButtonBlueContained>
}